import {PropertyType} from "./property-type";

export class Ratezone {
  id!: number;
  year!: number;
  propertyType = new PropertyType();
  property_construction_type_id!: number;
  rate!: number;
}
